export default __webpack_public_path__ + "static/media/14709 - Marcel.ed0d1a1a.jpeg";